import React, { useState } from 'react';
import DescriptionTab from './hooks/prodDescription';
import SpecificationsTab from './hooks/prodSpecifications';
import ImpactTab from './hooks/prodImpact';
import '../../../styles/ProductTabs.scss';

type Specification = {
  attribute_name: string;
  attribute_value: string;
};

interface Props {
  description: string;
  specifications: Specification[];
  impact: string;
}

const ProductTabs: React.FC<Props> = ({ description, specifications, impact }) => {
  const [activeTab, setActiveTab] = useState<'description' | 'specifications' | 'impact'>('description');

  const hasDescription = !!description?.trim();
  const hasSpecifications = specifications && specifications.length > 0;
  const hasImpact = !!impact?.trim();

  return (
    <div className="product-tabs">
  <div className="tab-buttons">
    <button
      className={`tab-button ${activeTab === 'description' ? 'active' : ''}`}
      onClick={() => hasDescription && setActiveTab('description')}
      disabled={!hasDescription}
    >
      Description
    </button>
    <button
      className={`tab-button ${activeTab === 'specifications' ? 'active' : ''}`}
      onClick={() => hasSpecifications && setActiveTab('specifications')}
      disabled={!hasSpecifications}
    >
      Specifications
    </button>
    <button
      className={`tab-button ${activeTab === 'impact' ? 'active' : ''}`}
      onClick={() => hasImpact && setActiveTab('impact')}
      disabled={!hasImpact}
    >
      Impact
    </button>
  </div>

  <div className="tab-content">
    {activeTab === 'description' && <DescriptionTab description={description} />}
    {activeTab === 'specifications' && <SpecificationsTab specifications={specifications} />}
    {activeTab === 'impact' && <ImpactTab impact={impact} />}
  </div>
</div>

  );
};

export default ProductTabs;
